import { format } from "date-fns";

export const formatDate = (dateString: string) =>
  new Date(dateString).toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "UTC",
    timeZoneName: "short",
  });

/**
 * Returns true if the given dates span more than one calendar year. Used by
 * chart axis labels to decide whether to print the year — when all bars or
 * points fall within the same year, repeating the year on every label is
 * just visual noise.
 */
export const spansMultipleYears = (dates: Date[]): boolean => {
  if (dates.length === 0) return false;
  const firstYear = dates[0].getFullYear();

  return dates.some((d) => d.getFullYear() !== firstYear);
};

/**
 * Format a date for chart axis labels. Drops the year when `showYear` is
 * false (the typical case for single-year ranges) so labels stay compact.
 */
export const formatChartDate = (date: Date, showYear: boolean): string =>
  format(date, showYear ? "MMM dd, yyyy" : "MMM dd");

export const formatLocalDate = (dateString: string) =>
  new Date(dateString).toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });

export const toEpoch = (date: Date) => Math.floor(date.getTime() / 1000);

export const utcStartOfDay = (date: Date) =>
  new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0),
  );

export const utcEndOfDay = (date: Date) =>
  new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      23,
      59,
      59,
      999,
    ),
  );
